module.exports = __webpack_public_path__ + "58a75dd50e1266785fa052c04d35c456.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/arun-michael-dsouza.jpg
// module id = 657
// module chunks = 0